<template>
    <svg id="Calque_1" data-name="Calque 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 34.43 28.7">
        <title>phone</title>
        <g id="map">
            <path d="M5,28.7a5,5,0,1,1,0-10,.72.72,0,0,1,0,1.44,3.59,3.59,0,1,0,0,7.17A.72.72,0,0,1,5,28.7Z" style="fill: #fff" />
            <path d="M.72,5.74A.72.72,0,0,1,0,5,5,5,0,0,1,5,0,.72.72,0,0,1,5,1.44,3.59,3.59,0,0,0,1.43,5,.72.72,0,0,1,.72,5.74Z" style="fill: #fff" />
            <path d="M29.41,28.7H5a.72.72,0,0,1,0-1.44H29.41a.72.72,0,0,1,0,1.44Z" style="fill: #fff" />
            <path d="M5,20.09a.72.72,0,0,1-.72-.72V.72a.72.72,0,1,1,1.43,0V19.37A.72.72,0,0,1,5,20.09Z" style="fill: #fff" />
            <path d="M.72,24.39A.72.72,0,0,1,0,23.67V5A.72.72,0,1,1,1.43,5V23.67A.72.72,0,0,1,.72,24.39Z" style="fill: #fff" />
            <path d="M29.41,28.7a.72.72,0,0,1,0-1.44,3.59,3.59,0,1,0,0-7.17.72.72,0,0,1,0-1.44,5,5,0,0,1,0,10Z" style="fill: #fff" />
            <path d="M33.72,5.74A.72.72,0,0,1,33,5a3.59,3.59,0,0,0-3.59-3.59.72.72,0,0,1,0-1.44,5,5,0,0,1,5,5A.72.72,0,0,1,33.72,5.74Z" style="fill: #fff" />
            <path d="M29.41,20.09a.72.72,0,0,1-.72-.72V.72a.72.72,0,1,1,1.43,0V19.37A.72.72,0,0,1,29.41,20.09Z" style="fill: #fff" />
            <path d="M33.72,24.39a.72.72,0,0,1-.72-.72V5a.72.72,0,1,1,1.43,0V23.67A.72.72,0,0,1,33.72,24.39Z" style="fill: #fff" />
            <path d="M29.41,5.74H5A.72.72,0,0,1,5,4.3H29.41a.72.72,0,0,1,0,1.44Z" style="fill: #fff" />
            <path d="M19.37,18.65a.71.71,0,0,1-.51-.21L13.12,12.7a.72.72,0,0,1,1-1l5.74,5.74a.72.72,0,0,1-.51,1.22Z" style="fill: #fff" />
            <path d="M13.63,18.65a.72.72,0,0,1-.51-1.22l5.74-5.74a.72.72,0,0,1,1,1l-5.74,5.74A.71.71,0,0,1,13.63,18.65Z" style="fill: #fff" />
        </g>
    </svg>
</template>

<script>
export default {
    name: "MapIcon",
};
</script>

<style scoped></style>
